import React, { Component } from 'react';
// import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { showModal } from '../../../../actions/ModalActions';
import { grabGuestByUuid } from '../../../../actions/PublicWebsiteActions';
/* css imports */
import './TrackRsvpNotifications.less';
import NotificationActionComponent from './NotificationActionComponent';


class TrackRsvpsNotification extends Component {

  constructor(props) {
    super(props);
    this.state = {
      altActive: false,
      notificationPage: false,
      activeGuestPage: false,
      notificationObject: {},
    };
  }

  componentWillMount() {
    const { params, grabGuest } = this.props;
    const { rsvpUUID } = params;
    grabGuest(rsvpUUID);
  }

  render() {
    const { guestRequestNotifications, onDecline, grabGuest, triggerConfirmation, notificationObject, } = this.props;
    return (
      <div id="rsvp-notifications">
        <div className="body">
          <NotificationActionComponent
            triggerConfirmation={triggerConfirmation}
            handleAddGuestState={this.handleAddGuestState}
            onDecline={onDecline}
            notificationObject={notificationObject}
            guestRequestNotifications={guestRequestNotifications}
            grabGuest={grabGuest}
            triggerBackState={this.triggerBackState}
          />
        </div>
      </div>
    );
  }
}

TrackRsvpsNotification.propTypes = {
  guestRequestNotifications: PropTypes.arrayOf(PropTypes.shape({})),
  onDecline: PropTypes.func,
  grabGuest: PropTypes.func,
  triggerConfirmation: PropTypes.func,
  notificationObject: PropTypes.shape({}),
  // onGetGuestRequests: PropTypes.func,
  params: PropTypes.shape({})
};

const mapStateToProps = state => (
  {
    guestRequestNotifications: state.publicWebsite.guestRequestObject,
    addGuestPage: state.publicWebsite.addGuestPage,
    notificationObject: state.publicWebsite.guestRequestByUuid,
  }
);

const mapDispatchToProps = dispatch => (
  {
    triggerConfirmation: notificationObject => dispatch(showModal('DECLINE_RSVP_REQUEST', { notificationObject }, { size: 'md' })),
    grabGuest: guestUuid => dispatch(grabGuestByUuid(guestUuid)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackRsvpsNotification);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/trackRsvpNotifications/TrackRsvpNotifications.jsx